import { useMikMakTag } from './mikmak';
export const pushContentInteraction = ({
  journey_type,
  interaction_type,
  interaction_name,
  page_type,
  widget_type
}) => {
  if (typeof window !== 'undefined') {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'content_interaction',
      journey_type,
      interaction_type,
      interaction_name,
      page_type,
      widget_type
    });
    console.log(window.dataLayer);
  }

 
};
